import api, { createApiService } from "../http";
import { RequestGetAll } from "../types/services-types/http-types";
import { IRegistryBookMemory } from "../types/services-types/registry-types";

export default class RegistryBookMemoryService {


    static apiRegistryBookMemoryService = createApiService('/registry-book-memory')

    static async AddFromExcel(formData: FormData) {
        const response = await this.apiRegistryBookMemoryService.post<IRegistryBookMemory[]>('/add-from-excel', formData)
        return response.data
    }

    static async Add(json: Object) {
        const response = await this.apiRegistryBookMemoryService.post<IRegistryBookMemory>('/add', json)
        return response.data
    }

    static async Update(data: Object) {
        const response = await this.apiRegistryBookMemoryService.post<IRegistryBookMemory>(`/update`, data)
        return response.data
    }

    static async Get(id: number) {
        const response = await this.apiRegistryBookMemoryService.get<IRegistryBookMemory>(`/${id}`)
        return response.data
    }

    static async GetAll(limit: number, page: number) {
        const response = await this.apiRegistryBookMemoryService.get<RequestGetAll<IRegistryBookMemory[]>>('/all', {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetAllFilters(limit: number, page: number, form: Object) {
        const response = await this.apiRegistryBookMemoryService.get<RequestGetAll<IRegistryBookMemory[]>>('/all-filters', {
            params: {
                ...form,
                limit,
                page
            }
        })
        return response.data
    }

    static async Delete(id: number) {
        const response = await this.apiRegistryBookMemoryService.post(`/delete/${id}`)
        return response.data
    }
}